import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserProfile } from '@app-libs/model';
import { Observable } from 'rxjs';
import { ConfigurationClientService } from '../client/configuration-client.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileApiService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigurationClientService
  ) {
    this.baseUrl = this.configService.getBackendAPIUrl() + '/profile';
  }

  getProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.baseUrl);
  }

  updateProfile(profileData: Partial<UserProfile>): Observable<UserProfile> {
    return this.http.put<UserProfile>(this.baseUrl, profileData);
  }

  updateProfileBasic(profileData: Partial<Pick<UserProfile, 'first_name' | 'last_name' | 'additional_info'>>): Observable<UserProfile> {
    return this.http.put<UserProfile>(`${this.baseUrl}/basic`, profileData);
  }

  updateSelectedWorkspace(workspaceId: string): Observable<UserProfile> {
    return this.http.put<UserProfile>(`${this.baseUrl}/workspace`, {
      selected_workspace: workspaceId,
    });
  }
}